import { Component, inject, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { DialogData } from '../task-complete-complete';
import { EAMPriorWorkRequest, TasklistService } from 'src/app/services/tasklist.service';
import { MatCardModule } from '@angular/material/card';
import { CommonModule, DatePipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LayoutModule } from '@angular/cdk/layout';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TextFieldModule } from '@angular/cdk/text-field';

@Component({
  selector: 'app-eam-associate-dialog',
  imports: [CommonModule, MatCardModule, MatDialogModule, MatButtonModule, DatePipe, FormsModule, LayoutModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, TextFieldModule, MatLabel],
  templateUrl: './eam-associate-dialog.component.html',
  styleUrl: './eam-associate-dialog.component.scss'
})
export class EamAssociateDialog implements OnInit {
  private dialogRef = inject(MatDialogRef<EamAssociateDialog>)
  private data:EamAssociateDialogType = inject(MAT_DIALOG_DATA);
  private svcTask = inject(TasklistService);
  private fb = inject(FormBuilder);

  protected requiredInputForm: FormGroup;

  protected priorWorkRequest:EAMPriorWorkRequest;

  protected input_data:string;
  protected required_input:string;
  protected showForm:boolean = false;
  protected processing:boolean = false;

  constructor() {
    this.priorWorkRequest = this.data.priorRequest;
    this.required_input = this.data.required_input;

    this.requiredInputForm = this.fb.group({
      input_data: (this.input_data == null) ? '' : this.input_data
    });

  }

  ngOnInit(): void {


    this.requiredInputForm.valueChanges.subscribe((formValues) =>{
      this.input_data = formValues.input_data
    });
  }

  showFormInput(): void {
    this.showForm = true;
  }

  save(): void {
    this.processing = true;
    this.svcTask.eamAssociate(this.data.Site, this.data.id, this.priorWorkRequest.id, this.input_data).subscribe(
      out => {
        this.close(false, true);
      }
    );
  }

  close(openNext:boolean=false, fetch:boolean=false): void {
    this.dialogRef.close({ OpenNext: openNext, Fetch: fetch })
  }
}

export type EamAssociateDialogType = {
  Site: string;
  id: number;
  required_input: string;
  priorRequest: EAMPriorWorkRequest;
}